/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-02 17:07:12
 */
import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, message, Spin } from "antd";
import axios from "@/axios/axios";
import "./index.less";
import electronic_book from "../../img/electronic_book.png";
export const CameraComponent = (props: any) => {
  const { REACT_APP_BASE_CONTINUE, REACT_APP_EXAM_URL } = process.env;
  const { showFaceModal, obj, setShowFaceModal, examNeedFaceFlag, onSuccess } =
    props;
  const [loading, setLoading] = useState(false);
  const cameraVideoRef = useRef(null);
  // 人脸识别类型
  const [faceType, setFaceType] = useState(1);
  // 人脸识别图片
  const [qrCodeBase64Image, setQrCodeBase64Image] = useState("");
  // 保存事件Id
  const [eventId, setEventId] = useState("");
  function successFunc(mediaStream: any) {
    const video = cameraVideoRef.current as any;
    // const video = document.getElementById('cameraVideo') as HTMLVideoElement;
    // 旧的浏览器可能没有srcObject
    if ("srcObject" in video) {
      video.srcObject = mediaStream;
    }
    video.onloadedmetadata = () => {
      video.play();
    };
  }
  const checkExam = async () => {
    const { courseId, sectionId } = obj;
    const { code, msg } = await axios.post(
      `/shop/exam/ce/check/item/${courseId}/section/${sectionId}/exam`
    );

    if (code === 0) {
      window.location.href = `${REACT_APP_BASE_CONTINUE}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=projectExam&itemId=${courseId}&sectionId=${sectionId}`;
    } else {
      message.error(msg);
    }
  };
  function errorFunc(err: { name: any; message: any }) {
    console.log("err", err);
    // Modal.info({
    //   title: "人脸识别",
    //   content: (
    //     <div>
    //       <p>未找到摄像头设备~。</p>
    //     </div>
    //   ),
    //   onOk() {
    //     window.history.go(-1);
    //   },
    // });
    setShowFaceModal(true);
  }
  // 启动摄像头
  const openMedia = () => {
    // 打开摄像头
    const opt = {
      video: {
        width: 1280,
        height: 720,
      },
    };
    navigator.mediaDevices.getUserMedia(opt).then(successFunc).catch(errorFunc);
  };
  // 关闭摄像头
  const closeMedia = () => {
    // const video = document.getElementById('cameraVideo') as HTMLVideoElement;
    const video = cameraVideoRef.current as any;
    const stream = video.srcObject;
    if ("getTracks" in stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track: { stop: () => void }) => {
        track.stop();
      });
    }
  };

  const getImg = () => {
    // 获取图片资源
    const video = cameraVideoRef.current;
    const canvas = document.createElement("canvas");
    canvas.style.width = "320px";
    canvas.style.width = "180px";
    // @ts-ignore
    const ctx = canvas.getContext("2d");
    // @ts-ignore
    ctx.drawImage(video, 0, 0, 320, 180); // 把视频中的一帧在canvas画布里面绘制出来
    // @ts-ignore
    const imgStr = canvas.toDataURL(); // 将图片资源转成字符串
    return imgStr;
  };
  const dataURLtoFile = (dataurl: string, filename: string) => {
    // 获取到base64编码
    const arr = dataurl.split(",");
    // 将base64编码转为字符串
    const bstr = window.atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n); // 创建初始化为0的，包含length个元素的无符号整型数组
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: "image/png",
    });
  };
  const saveImg = async () => {
    setFaceType(1);
    setLoading(true);
    // electron项目保存到本地
    const data = getImg() as any;
    const str = dataURLtoFile(data, "faceImageFile.png");
    const compareStr = dataURLtoFile(data, "compareFaceFile.png");
    const formData = new FormData();
    formData.append("faceImageFile", str);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    // const { code, msg } = await axios.post(
    //   "/user/api/ce/user/face/info/save",
    //   formData,
    //   config
    // );
    // 人脸信息比对
    await compareFaceImg(compareStr);
    setLoading(false);
  };
  /**
   * 比较人脸信息
   * @param str
   */
  const compareFaceImg = async (str: any) => {
    const formData = new FormData();
    formData.append("compareFaceFile", str);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const { code, msg } = await axios.post(
      "/user/api/ce/user/face/info/compare",
      formData,
      config
    );
    if (code === 0) {
      message.success("对比成功");
      examNeedFaceFlag && checkExam();
      setShowFaceModal(false);
      onSuccess();
      closeMedia();
    } else {
      message.info(msg);
    }
  };
  useEffect(() => {
    setFaceType(1);
    showFaceModal && openMedia();
  }, [showFaceModal]);
  /**
   * 切换人脸识别图片功能
   */
  const checkFaceImg = async () => {
    setFaceType(2);
    const {
      data: { qrCodeBase64Image, eventId },
    } = await axios.post("/user/api/ce/user/app/face/page/qrCode");
    setQrCodeBase64Image(qrCodeBase64Image);
    setEventId(eventId);
  };
  /**
   * 校验人脸信息是否通过
   */
  const compareFaceData = async () => {
    const { data } = await axios.post(
      `/user/api/ce/user/app/face/compare/${eventId}/result`
    );
    if (data === 0) {
      message.error("未完成识别~");
    } else {
      message.success("识别成功~");
      setShowFaceModal(false);
      onSuccess();
    }
  };
  return (
    <Modal
      open={showFaceModal}
      title="人脸识别"
      footer={null}
      onCancel={() => {
        setShowFaceModal(false);
      }}
      closable={false}
      mask={true}
      maskClosable={false}
    >
      <Spin
        tip="正在识别，请稍等..."
        spinning={loading}
        style={{
          textAlign: "center",
        }}
      >
        {faceType === 1 && (
          <>
            <video
              id="cameraVideo"
              ref={cameraVideoRef}
              style={{
                width: "100%",
                height: "320px",
                background: "black",
              }}
            />
            <p
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button onClick={saveImg} type="primary">
                拍照识别
              </Button>
              <Button
                onClick={() => {
                  checkFaceImg();
                  closeMedia();
                }}
                type="primary"
              >
                切换扫码识别
              </Button>
            </p>
            <p className="center">
              若您的电脑没有摄像头，可以通过《国家医学电子书包》APP扫码识别。
            </p>
            <p className="center">
              扫描下方二维码可以下载《国家医学电子书包》APP。
            </p>
            <p className="center">
              <img
                src={electronic_book}
                style={{
                  width: "140px",
                }}
              />
            </p>
          </>
        )}
        {faceType === 2 && (
          <>
            <p
              style={{
                textAlign: "center",
              }}
            >
              <img src={qrCodeBase64Image} />
            </p>
            <p
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  compareFaceData();
                }}
              >
                已完成识别
              </Button>
              <Button
                onClick={() => {
                  openMedia();
                  setFaceType(1);
                }}
                type="primary"
              >
                切换拍照识别
              </Button>
            </p>
            <p style={{ textAlign: "center" }}>
              APP扫码识别成功后点击已完成识别按钮。
            </p>
          </>
        )}
      </Spin>
    </Modal>
  );
};
